import { observer } from "mobx-react-lite";
import { KeyValueCustomSelect } from "@smartsuite/react-ui/lib";
import { useState } from "react";
import { CaptionBlock } from "../../../../../../../../components/CaptionBlock";
import { getLocalCssColorVariables } from "../../../../../../../../utils/cssVariablesUtils";
import { StyledReactSelectFieldContainer } from "../../../../SelectEditor/InputSelectStyles";
import { useTheme } from "../../../../../../../../stores";

export const SortDirectionInput = observer<{
  value: string;
  options: Array<Record<string, unknown>>;
  onChange: (value: string) => void;
}>(({ value, options, onChange }) => {
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();
  const onOpendChange = (e: boolean): void => {
    setOpen(e);
  };
  return (
    <StyledReactSelectFieldContainer className="hide-label" width={100}>
      <CaptionBlock
        description={{
          label: "Sort Dir",
          subLabel: "",
          icon: "",
          dynamic: false,
        }}
      />
      <KeyValueCustomSelect
        my="left top+2"
        state={open ? "active" : "default"}
        value={value}
        placeholder=""
        showClear={false}
        placeholderArrowStyle="filled-dark"
        options={options}
        className={open ? "container-is-open" : ""}
        portalStyles={getLocalCssColorVariables(theme)}
        onOpenedChange={onOpendChange}
        onChange={(value) => {
          onChange(value as string);
        }}
      />
    </StyledReactSelectFieldContainer>
  );
});
